import { render, staticRenderFns } from "./ProductVideos.vue?vue&type=template&id=7c254ee4&"
import script from "./ProductVideos.vue?vue&type=script&lang=js&"
export * from "./ProductVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports